export default "__VITE_ASSET__BnZykzk5__"